module.exports = __webpack_public_path__ + "assets/img/type1.8fa35d8c.png";